import { DialogContentText, DialogContent } from '@mui/material';
import { type FC, useCallback } from 'react';

import { useMutateDeleteCategory } from '../../api/index.js';
import { type CodeCategory } from '../../models/index.js';
import { Events, track } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface CategoryDeleteProps {
  open: boolean;
  onClose: () => void;
  category?: CodeCategory;
  refetch: () => void;
}

const CategoryDelete: FC<CategoryDeleteProps> = ({ open, onClose, category, refetch }) => {
  const deleteMutation = useMutateDeleteCategory();

  const onSubmit = useCallback(async () => {
    if (category?.id) {
      return deleteMutation.mutateAsync(category.id);
    }
  }, [category, deleteMutation]);

  const trackFn = useCallback(() => {
    track(Events.CategoryDelete, {
      categoryId: category?.id,
    });
  }, [category]);

  return (
    <DeleteDialog
      open={open}
      name={'category'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
      trackFn={trackFn}
    >
      {category ? (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{category.name}</DialogContentText>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default CategoryDelete;
